module.exports = __webpack_public_path__ + "static/media/loadingMain.2583b43d.gif";